<template>
    <div class="code-choice-slider">
        <div class="choices">
            <div class="slider-line">
                <div class="slider-notch"></div>
            </div>

            <button id="selection-raw" class="null" @click="change('raw')">RAW</button>
            <button id="selection-scss" class="null" @click="change('scss')">SCSS</button>
            <button id="selection-json" class="null" @click="change('json')">JSON</button>
            <button id="selection-php" class="null" @click="change('php')">PHP</button>
        </div>
    </div>
</template>

<script>
    import RawOutput  from '../../Outputs/Contexts/RawOutput';
    import ScssOutput from '../../Outputs/Contexts/ScssOutput';
    import JsonOutput from '../../Outputs/Contexts/JsonOutput';
    import PhpOutput  from '../../Outputs/Contexts/PhpOutput';

    export default {
        name: 'OutputContexts',

        props: {
            value: {},
        },

        data() {
            return {
                contexts: {
                    raw: RawOutput,
                    scss: ScssOutput,
                    json: JsonOutput,
                    php: PhpOutput,
                },
            }
        },

        methods: {
            change(type) {
                this.animateCodeFormatSelection(type)
                this.$emit('input', this.contexts[type]);
            },

            animateCodeFormatSelection(format) {
                let position = document.getElementById('selection-' + format).offsetTop;

                TweenMax.to('.slider-notch', 0.5, {
                    top: position + 12,
                    ease: Power4.easeOut,
                });
            },
        },

        mounted() {
            this.animateCodeFormatSelection('raw');
        },
    }
</script>

<style lang="scss" scoped>
    .code-choice-slider {
        button {
            display: block;
        }
    }
</style>
